import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AuthenticationService } from '../authentication.service';
import { MatSnackBar } from '@angular/material';


@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
    constructor(private authenticationService: AuthenticationService, protected msg: MatSnackBar) { }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(request).pipe(catchError(err => {
            if (err.status === 401) {
                // auto logout if 401 response returned from api
                if(sessionStorage.getItem('soo_login')=='1')
                    this.authenticationService.redirectToPanel()
                  else
                    this.authenticationService.logout();
                // this.authenticationService.logout();
                location.reload();
            }

            if (err.status === 406) {
                // auto logout if 406 response returned from api
                console.log("Error of 406, as wrong session is requested");
                if(sessionStorage.getItem('soo_login')=='1')
                    this.authenticationService.redirectToPanel()
                  else
                    this.authenticationService.logout();
                // this.authenticationService.logout();
                // location.reload();
            }

            if (err.status === 410) {
                // auto logout if 410 response returned from api
                console.log("Error of 410, as wrong session is requested");
                if(sessionStorage.getItem('soo_login')=='1')
                    this.authenticationService.redirectToPanel()
                  else
                    this.authenticationService.logout();
                // this.authenticationService.logout();
                location.reload();
            }

            if (err.status === 404) {
                console.log("Error of 404, No Data Found");
                // this.msg.open('No data Found', 'Clear', {
                //     duration: 3000
                //     ,verticalPosition: 'top',
                //      horizontalPosition: 'center',
                //      panelClass:['snackbarwarn']
                //   });
            }

            if (err.status === 403) {
                console.log("Error of 403, Access Forbidden");
                this.msg.open('Access Forbidden', 'Clear', {
                    duration: 3000
                    , verticalPosition: 'top',
                    horizontalPosition: 'center',
                    panelClass: ['snackbarwarn']
                });
            }

            // const error = err.error.message || err.statusText;
            const error = err.error || err.statusText;
            return throwError(error);
        }))
    }
}